const PACKAGE_VERSION = "1.28.2";
const TARGETED_RPC_VERSION = "1.48.0";
export {
  PACKAGE_VERSION,
  TARGETED_RPC_VERSION
};
